import { render, staticRenderFns } from "./centroresultados.vue?vue&type=template&id=c82a6372"
import script from "./centroresultados.vue?vue&type=script&lang=js"
export * from "./centroresultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports